<script>
import { teststore } from './teststore.js'
import TestPaintItem from './TestPaintItem.vue'

export default {
  components: {
    TestPaintItem,
  },
  data() {
    return {
      teststore
    }
  },

  created(){

  },
  mounted(){
    
  },
  updated() {
    window.opengraphmakeshot();
  },
  methods: {
  },
};
</script>

<template>

 <div id="test-wrapper" class="opengraphiqitem og-wrapper" style="visibility:hidden;">
 <div id="test-wrapper-inner" class="opengraphiqitem og-wrapper-inner" style="visibility:hidden; width:1200px; height:630px">
  
      <TestPaintItem v-for="(item, index) in teststore.domelements" :item="item" :index="index" :key="item.id" />
  
    </div>
  </div>

</template>